<ng-container *mobxAutorun>
  <ion-header class="ion-align-items-center outer ion-no-border" *ngIf="modal">
    <ion-toolbar>
      <div class="ion-justify-content-between ly-row ion-align-items-center">
        <div class="md-title-set ly-row ion-align-items-center">
          <ion-icon class="ion-margin-end" name="list" size="large"> </ion-icon>
          <ion-text>
            <h3>
              {{ 'addAccountText' | translate }}
            </h3>
          </ion-text>
        </div>
        <ion-button
          fill="clear"
          shape="round"
          class="button-icon ion-no-margin"
          color="medium"
          (click)="modal.dismiss()"
        >
          <ion-icon slot="icon-only" name="close"> </ion-icon>
        </ion-button>
      </div>
    </ion-toolbar>
  </ion-header>

  <ng-template #counter let-step="step" let-total="total">
    <step-counter [step]="step" [total]="total" color="light"> </step-counter>
  </ng-template>

  <ion-row *ngIf="showTitles" class="ion-margin-vertical">
    <ion-text color="dark">
      <h4>{{ 'components.accountConnect.titles.addHeader' | translate }}</h4>
    </ion-text>
  </ion-row>
  <ion-grid class="body">
    <ion-grid
      class="body-inner ion-align-items-start"
      joyrideStep="selectSocial"
      [title]="'components.accountConnect.tour.selectSocial.title' | translate"
      [text]="'components.accountConnect.tour.selectSocial.body' | translate"
      [counterTemplate]="counter"
      (next?)="finishTourStep()"
    >
      <div
        class="ly-row flex-wrap ion-padding-horizontal ion-margin-horizontal social-container ion-justify-content-between"
      >
        <div
          class="ly-col ion-margin-horizontal margin-auto"
          *ngFor="let connection of $any(isLoading ? ['', '', '', ''] : connections)"
        >
          <ion-col col-6 class="social-media-column">
            <ion-button
              class="social-media-card {{
                connection.service ? connection.service : 'loading'
              }} ion-no-margin flat"
              [disabled]="isLoading"
              [class.slim]="slim"
              (click)="
                connection.service === 'instagram'
                  ? instagramButton(connection)
                  : connection.authenticate(connection)
              "
            >
              <div class="ly-row ion-align-items-start" style="margin-right: auto; padding-left: 46px;">
                <ion-icon
                  *ngIf="connection.service !== 'twitter'"
                  [name]="connection.service ? 'logo-' + connection.service : 'cloud-circle'"
                ></ion-icon>
                <div *ngIf="connection.service === 'twitter'">
                  <img
                    [src]="'assets/img/x-logo-new.png'"
                    width="42px"
                  />
                </div>
                <ion-label *ngIf="!isLoading && connection.service !== 'twitter'" class="ion-text-capitalize ion-margin-top">
                  &nbsp;&nbsp;
                  {{ connection.service }}
                </ion-label>
                <ion-label 
                  *ngIf="!isLoading && connection.service === 'twitter'" 
                  class="ion-text-capitalize twitter-ion-label">
                  &nbsp;&nbsp;
                  <span *ngIf="connection.service === 'twitter'">X</span>
                </ion-label>
                <ion-skeleton-text *ngIf="isLoading" animated></ion-skeleton-text>
              </div>
            </ion-button>
          </ion-col>
        </div>
      </div>
    </ion-grid>
  </ion-grid>

  <ion-row class="ion-margin-vertical" *ngIf="showTitles">
    <ion-text color="dark">
      <h4 class="ion-no-margin">
        {{ 'components.accountConnect.titles.socialHeader' | translate }}
      </h4>
    </ion-text>
  </ion-row>

  <ion-row *ngIf="showAccounts && accounts && accounts.length" class="ion-align-items-center">
    <ion-list class="flex">
      <ion-item *ngFor="let account of accounts">
        <entity-avatar [entity]="account" class="ion-margin-end"> </entity-avatar>
        <ion-label>{{ account.formattedLabel }}</ion-label>
        <ion-button slot="end" fill="clear" color="danger" (click)="deleteAccount(account)">
          {{ 'removeText' | translate }}
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  </ion-row>
</ng-container>
